<template>
  <el-dialog
    title="修改基本信息"
    :visible.sync="dialogFormEditCompanyInfo"
    @close="close"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="rules" label-width="100" ref="form">
      <el-form-item label="渠道商名称：" prop="distributorName">
        <el-input v-model="form.distributorName"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>

      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { modifySecondInfo } from '@/api/distributor-api'
import { SERVICE_PROVIDER_CREATE_RULE } from '@/views/service/rules'
export default {
  props: {
    infoData: {
      require: true,
    },
  },
  components: {},
  mixins: [],
  data() {
    return {
      dialogFormEditCompanyInfo: false,
      distributorId: this.$route.params.id,
      form: {
        distributorName: '',
      },
      defaultForm: {},
      rules: SERVICE_PROVIDER_CREATE_RULE.call(this),
    }
  },
  watch: {
    infoData(val) {
      this.form = Object.assign({}, val)
      this.defaultForm = Object.assign(this.defaultForm, val)
    },
  },
  computed: {},
  mounted() {},
  created() {},
  filters: {},
  methods: {
    showDialog() {
      this.dialogFormEditCompanyInfo = true
      this.form = Object.assign({}, this.infoData)
      this.defaultForm = Object.assign(this.defaultForm, this.infoData)
    },
    close() {
      this.$refs.form.resetFields()
      this.dialogFormEditCompanyInfo = false
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.updateFirstClientInfo()
        } else {
          return false
        }
      })
    },
    async updateFirstClientInfo() {
      let { distributorName } = this.form
      let { distributorId } = this
      let submitForm = Object.assign({}, this.form)
      submitForm.distributorId = distributorId
      if (distributorName !== this.defaultForm.distributorName) {
        await modifySecondInfo(submitForm)
        this.outMsg('success', '提交成功')
        this.close()
        this.$emit('submitSuccess')
      } else {
        this.close()
      }
    },
  },
}
</script>
